// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1kKyV","footer":"ModalCreateQualiphyProcedure_footer__1H4Is","additionData":"ModalCreateQualiphyProcedure_additionData__2_xyP"};